module.exports = __webpack_public_path__ + "static/media/Gilroy-Heavy.4ca59e02.ttf";